export default function CsharpServer() {
  return (
    <h2>Csharp Server</h2>
  );
}
